import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import "./index.css";
// Phase 3-i18n — bootstrap i18next before any UI mounts.
import "./lib/i18n";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);